import Image from 'next/image';
import { Portal, svgSprite } from '../../hybrid/wrappers';
import YoutubePlayer from '../youtubePlayer/YoutubePlayer';
import css from './NewsImage.module.scss';
import { useMemo, useState } from 'react';
import classNames from 'classnames';

const NewsImage = ({ item, customStyles = {} }) => {
    const [videoModal, showVideoModal] = useState(false);

    const playVideo = (e) => {
        e.preventDefault();
        e.stopPropagation();
        showVideoModal(true);
    };
    const closeVideoModal = (e) => {
        e.stopPropagation();
        showVideoModal(false);
    };
    const normalizedYoutubeID = useMemo(() => item?.youtube?.split('?')[0], [item.youtube]);

    const youtubeThumbnail = useMemo(() => `https://img.youtube.com/vi/${normalizedYoutubeID}/0.jpg`, [normalizedYoutubeID]);
    return (
        <>
            {item?.type_media === 'picture' ? (
                <Image alt={item.title} fill className={css.img} src={item?.image?.link || item?.image?.links?.original} />
            ) : item?.type_media === 'youtube' ? (
                <div className={css.video}>
                    <div onClick={playVideo} className={classNames(css.videoPlay, customStyles.videoPlay)}>
                        {svgSprite('play')}
                    </div>
                    <Image alt={item.title} fill className={css.img} src={youtubeThumbnail} />
                </div>
            ) : item?.type_media === 'video' ? (
                <div className={css.video}>
                    <div onClick={playVideo} className={classNames(css.videoPlay, customStyles.videoPlay)}>
                        {svgSprite('play')}
                    </div>
                    <video
                        src={item?.video?.link || item?.video?.links?.original}
                        disablePictureInPicture
                        controls={false}
                        playsInline
                        autoPlay
                        onPlay={(e) => {
                            e.target.pause();
                        }}
                    ></video>
                </div>
            ) : (
                <div className={css.imgEmpty}>{svgSprite('plug-load-image-gt')}</div>
                // <Img alt={item.title} fill className={css.img} src={'/src/img/news-default.png'} />
            )}
            {videoModal ? (
                <Portal closeHandler={closeVideoModal}>
                    <div className={css.videoModal}>
                        <div onClick={closeVideoModal} className={classNames('circleButton', css.videoModalClose)}>
                            {svgSprite('cross')}
                        </div>
                        {item?.type_media === 'video' ? (
                            <video playsInline controls autoPlay src={item?.video?.link || item?.video?.links?.original}></video>
                        ) : (
                            <YoutubePlayer videoId={normalizedYoutubeID} onlyId />
                        )}
                    </div>
                </Portal>
            ) : null}
        </>
    );
};

export default NewsImage;
